import React from 'react';
import styled from 'styled-components';

import { IncludedServices, Hotel } from '@lt/components/icons-react';

import BubbleIncludedService from 'src/components/Bubbles/BubbleIncludedServices';

export const SearchTypeIcon = (props) => {
  const { searchType } = props;

  const ICON = {
    hotel: <HotelIcon />,
    package: (
      <BubbleIncludedService>
        <StyledIncludedServices />
      </BubbleIncludedService>
    ),
  };

  return <Container>{ICON[searchType]}</Container>;
};

const Container = styled.span`
  margin-left: 4px;
  display: flex;
`;

const StyledIncludedServices = styled(IncludedServices)`
  height: 16px;
  stroke-width: 1.5px;
  display: inline-block;
`;

const HotelIcon = styled(Hotel)`
  height: 30px;
  width: 30px;
  stroke: #17181a;
`;
